import { withRouter } from "react-router-dom";
import { memo } from "react";

import OverviewHeader from "../../../../components/overview-header";

import FindingsList from "./components/FindingsList";

const Findings = ({
    supplierId
}) => {
    return (
        <div>
            <OverviewHeader 
                supplierId={ supplierId } 
            />

            <div className="mt-3">
                <FindingsList 
                    supplierId={supplierId} 
                />
            </div>
        </div>
    );
};

export default withRouter(memo(Findings)); 